import React, { useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import MovieRow from "../components/MovieRow";
import LiveChannelsRow from "../components/LiveChannelsRow";
import ActorsRow from "../components/ActorsRow";
import PlansSection from "../components/PlansSection";
import FeaturedMatches from "../components/FeaturedMatches";
import SupportChat from "../components/SupportChat";
import SupportNotice from "../components/SupportNotice";
import CategoriesMarquee from "../components/CategoriesMarquee";
import LoginModal from "../components/LoginModal";
import DetailModal from "../components/DetailModal";
import SearchModal from "../components/SearchModal";
import Footer from "../components/Footer";
import { sections } from "../mock";
import { Flame, Music2, Popcorn } from "lucide-react";

const iconFor = (key) => {
  if (key === "flame") return <Flame className="w-6 h-6 text-red-600" />;
  if (key === "music") return <Music2 className="w-6 h-6 text-red-500" />;
  if (key === "popcorn") return <Popcorn className="w-6 h-6 text-yellow-400" />;
  return null;
};

export default function Home() {
  const [loginOpen, setLoginOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <div className="min-h-screen bg-[#0a0a0c]">
      <Header onLogin={() => setLoginOpen(true)} onSearch={() => setSearchOpen(true)} />

      <main className="pb-32">
        <HeroSection onPlay={(slide) => setSelectedItem(slide)} />

        <FeaturedMatches />

        <div className="max-w-[1500px] mx-auto px-6 mt-16 mb-10">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
            Futebol, Novelas, Lutas, Filmes, Séries...
          </h2>
          <p className="text-red-500 mt-2 text-sm md:text-base max-w-3xl">
            Quase tudo de todos os streamings você encontra aqui, num só lugar!{" "}
            <a
              href={`https://wa.me/5588988676142?text=${encodeURIComponent("Olá! Quero saber mais sobre o UniPlay UHD - Filmes, Séries, Novelas e TV ao Vivo.")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-4 decoration-red-500/60 hover:text-red-400 hover:decoration-red-400 transition font-semibold"
            >
              Clique aqui.
            </a>
          </p>
        </div>

        {sections.map((s) => (
          <MovieRow
            key={s.id}
            title={s.title}
            description={s.description}
            icon={iconFor(s.icon)}
            items={s.items}
            onSelect={(it) => setSelectedItem(it)}
          />
        ))}

        <LiveChannelsRow onSelect={(c) => setSelectedItem({ ...c, isLive: true, title: c.name, image: c.image })} />

        <ActorsRow />

        <PlansSection />

        <Footer />
      </main>

      <CategoriesMarquee />
      <SupportChat />
      <SupportNotice />

      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} onSelect={(it) => { setSearchOpen(false); setSelectedItem(it); }} />
      <DetailModal item={selectedItem} onClose={() => setSelectedItem(null)} />
    </div>
  );
}
